import React, { Component } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Slider from "react-slick";
import styles from '../../Css/SpyneHome/Home.module.css'
import { imageSrc } from './HomeImagesConfig'; 
import { photos } from './TemplatePhotos';
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry";
// import {homeData} from './dynamicDataHomePage';
import Footer from '../Common/Footer';
import HomeBookDemoModal from '../Modals/HomeBookDemoModal'
import Axios from 'axios'

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
  } from 'react-accessible-accordion';
import Dropzone from 'react-dropzone';
import { homeData } from './dynamicDataHomePage';
import centralApi from '../../CentralAPIHandler/CentralAPIHandler'
import HomeDashBoard from './HomeDashBoard';
// redux
import {connect} from 'react-redux'
import {updateImageFileData,updateImageURL} from '../../Redux/Reducers/HomePageReducer/HomePageActionController'
import { isFirefox } from 'react-device-detect';

import posthog from 'posthog-js';

// posthog.init("phc_p92egRlXhuEzPYkMaQVakJl0XCI82X507N84clTaJHH", {api_host: 'https://app.posthog.com'});
posthog.init("FoIzpWdbY_I9T_4jr5k4zzNuVJPcpzs_mIpO6y7581M", {api_host: 'https://app.posthog.com'});

// Slider Script Start
function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={"left-arrow"}
        style={{ ...style, display: "inline-block"}}
        onClick={onClick}
      ><i className="fa fa-angle-double-left"></i>
      </div>
    );
  }
  
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <div
        className={"right-arrow"} 
        style={{ ...style, display: "inline-block" }}
        onClick={onClick}
      >
          <i className="fa fa-angle-double-right"></i>
      </div>
    );
  }
// settings2
  function SamplePrevArrow2(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={"left-real-slide-arrow"}
        style={{ ...style, display: "inline-block"}}
        onClick={onClick}>
      <i className="fa fa-long-arrow-left" aria-hidden="true"></i>
      </div>
    );
  }
  
  function SampleNextArrow2(props) {
    const { className, style, onClick } = props;
    return (
        <div
        className={"right-real-slide-arrow"} 
        style={{ ...style, display: "inline-block" }}
        onClick={onClick}>
          <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
      </div>
    );
  }
 // Slider script End  





 /**
  * Class
  */
class Home extends Component {
    constructor(props){
        super(props);
        this.state={
            listOfTabs:['automobile', 'fashion', 'fabric', 'furnishing','food','footwear', 'product'],
            comingSoonCheck: [true, true, true, true,false,false,false],
           
            isSubCategoryExist: false,
            copied: false,
            firstLoad: true,
            showAccordianTimeInterval: {
                show: true,
                timeInMs: 2000,
                expandItem: [
                    true,
                    false,
                    false,
                ]
            },
            dynamicDataForCurrCategory:{},
            sampleImagesForCurrCategory:[],
            setAccordianInterval:null,
            showDropBackground: false,
            activeElementsRef:{
                mobileSection: React.createRef(),
                webSection: React.createRef(),
                apiSection: React.createRef(),
                dashboardSection: React.createRef(),
            },
            showModal: false, 
            selectedSubCategory: ''
        }
    }

    handleHideModal =()=>{
        this.setState({
            ...this.state,
            showModal:false
        })
    }
    handleShowModal = (e) =>{
        e.stopPropagation()
        this.setState({
            ...this.state,
            showModal:true
        })
    }
    
    componentDidMount(){

        const queryString = window.location.search;

        const urlParams = new URLSearchParams(queryString);

        let category = urlParams.get('category');

        if(!category){
            const defaultCategory = 'automobile';
            this.setState({...this.state,dynamicDataForCurrCategory:{...homeData[defaultCategory]} });
            this.getDummySampleImages();
        }else{
            let index = this.state.listOfTabs.indexOf(category)
            this.setActiveTab(null,index,category);
        }

        const allSectionsContainer = document.getElementById('all-section-container');
        if(allSectionsContainer)
            allSectionsContainer.children[0].classList.add(styles['active']);


        document.addEventListener('scroll', this.setCurrentSectionActive);
        this.getEnterpriseDetails()
    }

    componentWillUnmount(){
        document.removeEventListener('scroll', this.setCurrentSectionActive);
    }

    getEnterpriseDetails = () => {
        Axios({
            method: "GET",
            url : process.env.REACT_APP_BASEURL + "/v2/enterprise/getByCode",
            params : {
                enterprise_code : "www.spyne.ai",
            }
        }).then(resp => {

            if(resp?.data?.status === 200){
                document.documentElement.style.setProperty("--primaryColor",resp.data?.data?.color)
                document.documentElement.style.setProperty("--secondaryColor",resp.data?.data?.secondary_color)
                document.cookie = `enterpriseId=${resp.data?.data?.enterprise_id}; path=/`;
                document.cookie = `apiKey=${resp.data?.data?.api_key}; path=/`;
            }else{
                // alertify.error('Could not find enterprise details')
            }
        
            
        })
    }

    

    componentDidUpdate(){
        const ele = document.getElementById('accordian-to-start-interval');
        if(ele && this.state.firstLoad){
            this.startAccordianChanges();
        }
    }

    /**
     * Get sample images
     * @param {*} prodCatId 
     * @param {*} prodSubCatId 
     */
    getDummySampleImages = async() => {
        try {
            const auth_key = 'fe4a909f-9e2f-461f-98fc-51c22a21aac6'
            
            const url = `${process.env.REACT_APP_BASEURL}/v2/product/fetchImages`;
            const resp = await centralApi.handleGetRequest(url,{
                auth_key : auth_key,
                enterprise_id: 'TaD1VC1Ko',
                prod_cat_id: this.state.dynamicDataForCurrCategory['prod_cat_id']?this.state.dynamicDataForCurrCategory['prod_cat_id']:'cat_d8R14zUNE',
                prod_sub_cat_id : this.state.dynamicDataForCurrCategory['product_sub_cat_id']?this.state.dynamicDataForCurrCategory['product_sub_cat_id']:null
            })
            if(resp && resp.status!==200) throw Error(resp['message'] || 'Unknown error occurred');
       
            const data = (resp && resp.data) ? [...resp.data] : [];
            this.setState({...this.state, sampleImagesForCurrCategory:data});
        } catch (error) {
            // console.log(error);
            this.setState({...this.state, sampleImagesForCurrCategory:[]});
        }
    }


    /**
     * Set active tab
     * @param {*} e 
     * @param {*} index 
     */
    setActiveTab=async(e,index,showSubCategory=false)=>{
        
        try {
            // console.log(showSubCategory,this.state.showSubCategory)
        //     await this.setState({
        //    ...this.state,
        //     showSubCategory: showSubCategory
        // }) 

            if(e && this.state.comingSoonCheck[index]){
                e.stopPropagation();
                this.props.history.push(`?category=${this.state.listOfTabs[index]}`);
            }

            if(!this.state.comingSoonCheck[index]){
                return
            }

            // console.log(index)
            const ulElement = document.getElementById('products-category-list')
            // console.log(ulElement.children.length)

            //update dynamic data for current tab
            let categoryToBeLoaded = this.state.listOfTabs[index] ? this.state.listOfTabs[index] : 'automobile';

            this.setState({...this.state,sampleImagesForCurrCategory:[]})

            ulElement.childNodes.forEach((li,i)=>{
                // console.log(li)
                if(i===index){
                    li.classList.add(`${styles['active']}`);
                }
                else{
                    li.classList.remove(`${styles['active']}`)
                }
            });
            if(homeData[categoryToBeLoaded]['isSubCategoryExist']){
                const  subCategory = homeData[categoryToBeLoaded]['subCategories'][0]
                await this.setActiveSubTab(null,categoryToBeLoaded,subCategory,0)
                return
            }else{
                await this.setState({...this.state,dynamicDataForCurrCategory:"",selectedSubCategory:'' });
                await this.setState({...this.state,dynamicDataForCurrCategory:homeData[categoryToBeLoaded],selectedSubCategory:'' });

            }
            
            // fetch sample images
            this.getDummySampleImages();
        } catch (error) {
            //console.log(error)
        }
    }
    

    handleCopy = (e) =>{ 
        
        const element = document.getElementById('CurlText');
        navigator.clipboard.writeText(element.innerText)
        //var text=`Copied the text: ${element}`.toString()
        this.setState({...this.state,copied: true});
        setTimeout(()=>{
            this.setState({...this.state,copied: false});
        },1000)

    }

/******ACCORDIAN AUTOMATION START*******/
    /**
     * Stops automatic accordian and changes to manual
     * @param {*} accorDianItemUUID 
     */
    stopAutomaticAccordian = (accorDianItemUUID)=>{
        try {
            if(this.state.setAccordianInterval){
                clearInterval(this.state.setAccordianInterval);
            }
            
            accorDianItemUUID = accorDianItemUUID[0];
            let itemIndex =  accorDianItemUUID ? accorDianItemUUID.split('_') : [];

            itemIndex = itemIndex.length ? parseInt(itemIndex[itemIndex.length-1]) : 0;

            let newExpandItems = [...this.state.showAccordianTimeInterval.expandItem].map( (showItem,index)=>{
                if(index===itemIndex) return true;
                return false
            } );
            
            this.setState({
                ...this.state,
                setAccordianInterval: null,
                showAccordianTimeInterval:{
                    ...this.state.showAccordianTimeInterval,
                    show: true,
                    expandItem: newExpandItems,
                }
            })
        } catch (error) {
            //console.log(error);
        }
    }

    /**
     * Starts automatic accordian
     * @param {*} e 
     */
    startAccordianChanges = (e)=>{
        try {
            if(e)
                e.stopPropagation();

            const accordionIntervalId = setInterval(()=>{

                let newExpandItems = [...this.state.showAccordianTimeInterval.expandItem];
                let prevVal = newExpandItems[0];
                for(let i=1; i<newExpandItems.length; i++){
                    let currVal = newExpandItems[i];
                    newExpandItems[i] = prevVal;
                    prevVal = currVal;
                }
                newExpandItems[0] = prevVal;

                this.setState({
                    ...this.state,
                    showAccordianTimeInterval:{
                        ...this.state.showAccordianTimeInterval,
                        show: true,
                        expandItem: newExpandItems
                    }
                })
            }, this.state.showAccordianTimeInterval.timeInMs);


            this.setState({...this.state,setAccordianInterval:accordionIntervalId, firstLoad: false});
            
        } catch (error) {
            //console.log(error)
        }
    }

/******ACCORDIAN AUTOMATION END*******/

/***DROPZONE DROP AREA FUNC START*******/

    openFileDrop = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        this.setState({...this.state,showDropBackground:true})
    } 

    closeFileDrop = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        this.setState({...this.state,showDropBackground:false})
    } 

/***DROPZONE DROP AREA FUNC END*******/

    /**
     * Upload single image
     * @param {*} e 
     * @returns 
     */
    handleImageChoice = async(e) => {
        try {
            e.stopPropagation();
            e.preventDefault();
            const file = e.target.files[0];
            posthog.capture('Web image uploaded')
            if( !file ) return;

            await this.props.updateImageFileData(file); // save to store
            await this.props.updateImageURL('') // save to store

            if(!this.state.dynamicDataForCurrCategory['redirect_url']) throw Error('No redirect url present')
            
            this.props.history.push(this.state.dynamicDataForCurrCategory['redirect_url']);
        } catch (error) {
            //console.log(error);
        }
    }


    uploadSingleDropzoneFile = async(files) => {
        try {
            if(this.state.dynamicDataForCurrCategory?.['subCategories']){
                const byPassCategories = ['suit','bedsheet']
                let byPass = false
                for(let category of byPassCategories){
                    if(category === this.state.selectedSubCategory){
                        byPass = true
                        break;
                    }
                }
                if(byPass){
                    throw Error('DropZone Not Allowed for this Category')
                }
            }
            // pick only first file
            const newFile = (files && files.length) ? files[0] : null;

            if(!newFile) throw Error('No file received in dropzone');

            await this.props.updateImageFileData(newFile); // send to store
            await this.props.updateImageURL('') // save to store

            await this.setState({...this.state, showDropBackground: false});

            if(!this.state.dynamicDataForCurrCategory['redirect_url']) throw Error('No redirect url present')
            
            this.props.history.push(this.state.dynamicDataForCurrCategory['redirect_url']);

        } catch (error) {
            this.setState({...this.state, showDropBackground: false});
        }
    }



    /**
     * Logic to store sample image url
     * @param {*} e 
     * @param {*} imageHresURL 
     */
    updateURLonStore = async(e,sampleImagesForCurrCategory,imageHresURL,tryImageId,tryImageProdCatName,subCategoryId,index)=>{
        try {
            e.stopPropagation();
            e.preventDefault();
            posthog.capture('Web Try Images',{"ImageID":tryImageId, "ImageProdCatName":tryImageProdCatName})// try images id send
            await this.props.updateImageURL(imageHresURL,subCategoryId,index,sampleImagesForCurrCategory,"home");
            await this.props.updateImageFileData({});

            if(!this.state.dynamicDataForCurrCategory['redirect_url']) throw Error('No redirect url present')
            
            this.props.history.push(this.state.dynamicDataForCurrCategory['redirect_url']);

        } catch (error) {
            //console.log(error)
        }
    }


    /**
     * Scroll to sections on click
     * @param {*} e 
     * @param {*} refKey 
     * @param {*} index 
     */
    scrollToRef = (e, refKey='mobileSection', index=0)=>{
        try {
            e.stopPropagation();
            window.scrollTo(0,this.state.activeElementsRef[refKey].current.offsetTop);

            const allSectionContainer = document.getElementById('all-section-container');
            // set active
            allSectionContainer.childNodes.forEach((child,i)=>{
                if(i===index){
                    child.classList.add(styles['active'])
                }else{
                    child.classList.remove(styles['active'])
                }
            })

        } catch (error) {
            //console.log(error);
        }
    }


    /**
     * Set active tabs on scroll
     * @param {*} e 
     */
    setCurrentSectionActive = (e)=>{
        try {
            let currentScroll = document.documentElement.scrollTop;
            const index = {
                mobileSection: 0,
                webSection: 1,
                apiSection: 2,
                dashboardSection: 3,
            }
            for(let key in this.state.activeElementsRef){
                const currRef = this.state.activeElementsRef[key].current;
                if((currentScroll >= currRef.offsetTop) && (currentScroll <= (currRef.offsetTop + currRef.offsetHeight))){
                    const allSectionContainer = document.getElementById('all-section-container');

                    // set active
                    allSectionContainer.childNodes.forEach((child,i)=>{
                        if(i===index[key]){
                            child.classList.add(styles['active'])
                        }else{
                            child.classList.remove(styles['active'])
                        }
                    })
                    // console.log(currRef);
                }
            }
        } catch (error) {
            // console.log(error);
        }
    }



// Subcategory Tab
    setActiveSubTab=async(e,category='',subCategory='',index=0)=>{
        try {
            if(!subCategory || !category){
                return
            }
            if(e){
                e.stopPropagation()
            }
            
            
            
            const subCategoryData = homeData[category][subCategory];
            const categoryData = {...homeData[category],...subCategoryData};
            await this.setState({...this.state,dynamicDataForCurrCategory: categoryData,selectedSubCategory:subCategory});

            const element = document.getElementById('subcategory-selection')
            // console.log(element.childNodes)
            if(element && element.childNodes.length){
                element.childNodes.forEach((button,i)=>{
                    if(i===index){
                       
                        button.classList.add(`${styles['selected']}`)
                    }
                    else{
                        
                        button.classList.remove(`${styles['selected']}`)
                    }
                })
            }

            // console.log(categoryData)
            this.getDummySampleImages()

        } catch (error) {
            // console.log(error)
        }
    }

    // handleTryNowButton = (e) =>{
    //     try {
    //         if(e){
    //             e.stopPropagation()
    //         }
    //         const url = this.state.dynamicDataForCurrCategory['redirect_url']
    //         if(!url){
    //             return
    //         }
    //         this.props.history.push(url)
    //     } catch (error) {
    //        console.log(error) 
    //     }
    // }



    render() { 
        // Slider Const 
    const settings = {
        infinite: false,
        slidesToShow:4,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: false,
        speed: 500,responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
              }
            },
            {
              breakpoint: 320,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                infinite: false,
              }
            }
          ],
            nextArrow: <SampleNextArrow className="slider-arrow slider-prev fa fa-angle-left"/>,
            prevArrow: <SamplePrevArrow className="slider-arrow slider-next fa fa-angle-right"/>
        }; 
//End Slider
// Real stories Mobile View Slider Const 
const settings3 = {
    infinite: false,
    slidesToShow:1,
    dots: true,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: true,
    speed: 500,responsive: [
        {
          breakpoint: 1024,
          settings3: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings3: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 320,
          settings3: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ],
        nextArrow: <SampleNextArrow className="slider-arrow slider-prev fa fa-angle-left"/>,
        prevArrow: <SamplePrevArrow className="slider-arrow slider-next fa fa-angle-right"/>
    }; 

const settings1 = {
    infinite: false,
    slidesToShow:5,
    slidesToScroll: 1,
    swipeToSlide: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 7000,
    pauseOnHover: true,
    cssEase: 'linear',
    // speed: 500,
    responsive: [
        {
            breakpoint: 1180,
          settings1: {
            slidesToShow: 5,
            slidesToScroll: 1,
            dots: true
          }
        },
        {
          breakpoint: 1024,
          settings1: {
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: true
          }
        },
        {
          breakpoint: 600,
          settings1: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 320,
          settings1: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ],
        nextArrow: <SampleNextArrow className="slider-arrow slider-prev fa fa-angle-left"/>,
        prevArrow: <SamplePrevArrow className="slider-arrow slider-next fa fa-angle-right"/>
    }; 

    // Media Logos Const
    const settings4 = {
        infinite: false,
        slidesToShow:4,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 7000,
        pauseOnHover: true,
        cssEase: 'linear',
        // speed: 500,
        responsive: [
            {
                breakpoint: 1180,
              settings4: {
                slidesToShow: 4,
                slidesToScroll: 1,
                dots: true
              }
            },
            {
              breakpoint: 1024,
              settings4: {
                slidesToShow: 3,
                slidesToScroll: 1,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings4: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 320,
              settings4: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            }
          ],
            nextArrow: <SampleNextArrow className="slider-arrow slider-prev fa fa-angle-left"/>,
            prevArrow: <SamplePrevArrow className="slider-arrow slider-next fa fa-angle-right"/>
        }; 

    // Trusted Enterprise Slide 
    const settings2 = {
        infinite: true,
        slidesToShow:3,
        slidesToScroll: 1,
        swipeToSlide: true,
        autoplay: false,
        dots: true,
        centerMode: true, 
        centerPadding: "40px",
        speed: 500,responsive: [
            {
              breakpoint: 1024,
              settings2: {
                slidesToShow: 3,
                slidesToScroll: 1, 
              }
            },
            {
              breakpoint: 600,
              settings2: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 320,
              settings2: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ],
            nextArrow: <SampleNextArrow2 className="slider-prev"/>,
            prevArrow: <SamplePrevArrow2 className="slider-next"/>
        }; 
   
        return ( 
            <Dropzone onDrop={accepteSingleFile => this.uploadSingleDropzoneFile(accepteSingleFile)} onDragEnter={this.openFileDrop} onDragLeave={this.closeFileDrop}>
            {
                ({getRootProps, getInputProps}) => (

                        <div 
                            key='drop-zone-homepage'
                            {...getRootProps({
                                onClick: event => event.stopPropagation()
                            })} 
                            className={[styles['dropzone-main'],'home-main'].join(' ')}
                        >
                        {
                            this.state.showDropBackground ?
                            <section className={[styles['drop-box-text']]}>
                                <div>Drop Image Anywhere</div>  
                            </section>
                            : null
                        } 

                        

                        {/* Category tabs section  */}
                        <section className={[styles['category-tabs'],'category-tabs'].join(' ')}>
                            <div className={[styles[''],'container'].join(' ')}>
                                <div className={[styles[''],'row'].join(' ')}>
                                    <div className={[styles['category'],'col-md-12'].join(' ')}>
                                        <ul id="products-category-list">
                                            {
                                                this.state.listOfTabs.map((catTab,index)=>{
                                                    if(index === 0){
                                                        return (
                                                            <li key={`${catTab}_${index}`} onClick={(e)=>{this.setActiveTab(e,index)}} className={[styles['active'],''].join(' ')}><img src={imageSrc[index].src} alt=""/> <p>{catTab}</p></li>
                                                        )
                                                    }
                                                    return(
                                                        <li key={`${catTab}_${index}`} onClick={(e)=>{this.setActiveTab(e,index)}} className={ !this.state.comingSoonCheck[index] ? [styles['disable']] : ''}><img src={imageSrc[index].src} alt=""/> 
                                                        {
                                                           
                                                            (catTab === 'fabric') || (catTab === 'furnishing') ?
                                                            <p>{catTab}
                                                            <b className={[styles['arrow-up']]}> <i class="fa fa-caret-up" aria-hidden="true"></i></b>
                                                            <b className={[styles['arrow-down']]}> <i class="fa fa-caret-down" aria-hidden="true"></i></b>
                                                            </p>
                                                            : <p>{catTab}</p>
                                                        }
                                                        
                                                        
                                                        <span>Coming Soon</span></li>
                                                    )
                                                })
                                            }
                                            
                                        </ul>
                                        
                                    
                                    </div>
                                    {
                                            this.state.dynamicDataForCurrCategory?.['isSubCategoryExist']?
                                            <h5 id="subcategory-selection">
                                            {
                                            this.state.dynamicDataForCurrCategory?.['subCategories'].map((subCategory,index)=>{
                                                const category = this.state.dynamicDataForCurrCategory?.['category']
                                                    return(
                                                        <button key={subCategory+index} onClick={(e)=>this.setActiveSubTab(e,category,subCategory,index)}>{subCategory.toUpperCase()}</button>
                                                    )
                                                
                                            })
                                            }
                                            </h5>
                                            :null  
                                        }
                                </div>
                            </div>
                           
                        </section>

                        {/* Power your brand with photo */}
                        <section className={[styles['brand-with-photo'],''].join(' ')}>
                            <div className={[styles[''],'container'].join(' ')}>
                                <div className={[styles['hero-section'],'row'].join(' ')}>
                                    <div className={[styles['upload-image-area'],'col-md-6'].join(' ')}>
                                        <h1>{this.state.dynamicDataForCurrCategory?.['hero_section']?.['heading']}</h1>
                                        <p>{this.state.dynamicDataForCurrCategory?.['hero_section']?.['sub_heading']}</p>
                                        {/* <h6><button><i className="fa fa-upload" aria-hidden="true"></i> Upload Image</button> <span>Or drop a file</span></h6> */}
    
                                        <form encType='multipart/form-data'>
                                            {
                                                
                                               (this.state.selectedSubCategory === 'suit' || this.state.selectedSubCategory === 'bedsheet')?
                                                <h6 className={[styles[''],'d-md-block d-none'].join(' ')}><a target="_blank" href={`${process.env.REACT_APP_APP_DASHBOARD_PROJ_PREFIX}${this.state.dynamicDataForCurrCategory['redirect_url']}`}>Try Now</a></h6>
                                                : 
                                                <>
                                                <h6 className={[styles[''],'d-md-block d-none'].join(' ')}>
                                                <button onClick={e=>{e.preventDefault();e.stopPropagation();document.getElementById('homepageSingleImageUpload').click()}} >
                                                    <i className="fa fa-upload" aria-hidden="true"></i> Upload Image
                                                </button> 
                                                <span>Or drop a file</span>
                                            </h6>
                                            

                                            <input type="file" name="homepageSingleImageUpload" id="homepageSingleImageUpload" onChange={e=>{e.preventDefault();e.stopPropagation();this.handleImageChoice(e)}} accept="image/png, image/jpeg, image/jpg" style={{display:'none'}}/>
                                       
                                                </>
                                            }
                                             </form>

                                        <img src={this.state.dynamicDataForCurrCategory?.['hero_section']?.['banner_images'][0]} alt="" className={[styles[''],'d-block d-md-none mb-3'].join(' ')}/>
                                        <div className={[styles['upload-image-slider'],'row'].join(' ')}>
                                        {
                                        this.state.sampleImagesForCurrCategory.length ? 
                                        <>
                                        <h4>No image?Try one of these: <span><i className="fa fa-refresh" aria-hidden="true" onClick={this.getDummySampleImages}></i></span></h4>
                                            <Slider {...settings} className={[styles['upload-slider'],'col-md-10 col-lg-9 upload-slider'].join(' ')} > 
                                                {
                                                              
                                                    this.state.sampleImagesForCurrCategory.map((imageData, index)=>{
                                                        return (
                                                            <div className={[styles['try-more-col']]}>
                                                            <img 
                                                                src={imageData['image_url']} alt="" 
                                                                key={`${imageData['image_url']}_${index}`} 
                                                                onClick={e=>this.updateURLonStore(e,this.state.sampleImagesForCurrCategory,imageData['image_hres_url'],imageData['id'],imageData["category_name"],imageData["prod_sub_cat_id"],index)}
                                                            />
                                                            </div>
                                                        )
                                                    })
                                                    
                                                }
                                            </Slider>
                                            </>
                                            :null
                                             }
                                        </div>
                                        
                                    </div>
                                    <div className={[styles['right-banner-image'],'col-md-6'].join(' ')}> 
                                        <img src={this.state.dynamicDataForCurrCategory?.['hero_section']?.['banner_images'][0]} alt="" className={[styles[''],'d-md-block d-none'].join(' ')}/>
                                        {
                                                
                                                (this.state.selectedSubCategory === 'suit' || this.state.selectedSubCategory === 'bedsheet')?
                                                 <h6 className={[styles[''],'d-md-none d-block'].join(' ')}><a target="_blank" href={`${process.env.REACT_APP_APP_DASHBOARD_PROJ_PREFIX}${this.state.dynamicDataForCurrCategory['redirect_url']}`}>Try Now</a></h6>
                                                 : 
                                                 <>
                                                  <h6 className={[styles[''],'d-block d-md-none'].join(' ')}>
                                                    <button onClick={e=>{e.preventDefault();e.stopPropagation();document.getElementById('homepageSingleImageUpload').click()}} >
                                                        <i className="fa fa-upload" aria-hidden="true"></i> Upload Image
                                                    </button>  
                                                </h6>
                                             
 
                                             <input type="file" name="homepageSingleImageUpload" id="homepageSingleImageUpload" onChange={e=>{e.preventDefault();e.stopPropagation();this.handleImageChoice(e)}} accept="image/png, image/jpeg, image/jpg" style={{display:'none'}}/>
                                        
                                                 </>
                                             }
                                        
                                        
                                        {/* <h6 className={[styles[''],'d-block d-md-none'].join(' ')}>
                                            <button onClick={e=>{e.preventDefault();e.stopPropagation();document.getElementById('homepageSingleImageUpload').click()}} >
                                                <i className="fa fa-upload" aria-hidden="true"></i> Upload Image
                                            </button>  
                                        </h6> */}
                                    </div>
                                </div>
                            </div>
                            <span><button className={[styles['book-demo']]} onClick={this.handleShowModal}>book A Free demo </button></span>
                                <HomeBookDemoModal showModal={this.state.showModal} handleHideModal={this.handleHideModal}/>
                        </section>   
                          
                        {/* Trusted Enterprises  */}
                        <section className={[styles['trusted-enterprise'],''].join(' ')}>
                            <img src={imageSrc[19].src} className={[styles['star-bg']]} alt="" />
                            <div className={[styles[''],'container'].join(' ')}>
                                <div className={[styles[''],'row'].join(' ')}>
                                    <div className={[styles[''],'col-md-12'].join(' ')}>
                                        <h3>{this.state.dynamicDataForCurrCategory?.['enterprises_section']?.['heading']}</h3>
                                        <Slider {...settings1} className={[styles['trusted-clients'],'row trusted-clients'].join(' ')} >
                                                {
                                                    this.state.dynamicDataForCurrCategory?.['enterprises_section']?.['enterprises_list'] ?
                                                    this.state.dynamicDataForCurrCategory['enterprises_section']['enterprises_list'].map((imageData,index)=>
                                                    {
                                                        return (
                                                            <div className={[styles['clients-images'],''].join(' ')} key={`${imageData}_${index}`}>
                                                                <img src={imageData} alt=""/>
                                                            </div> 
                                                        )
                                                    })
                                                    : null
                                                }
                                            </Slider> 
                                    </div>
                                </div>
                            </div>
                        </section>
                    
                        {/* All scroll fixed sections Div*/}
                        <div className={[styles['scroll-area'],''].join(' ')}>
                            {/* Mobile App section*/}
                            <section className={[styles['mobile-app'],''].join(' ')} id="mobile-app" ref={this.state.activeElementsRef.mobileSection}> 
                                <div className={[styles[''],'container'].join(' ')}>
                                    <div className={[styles[''],'row'].join(' ')}>
                                        <div className={[styles['title'],'col-md-12 text-center'].join(' ')}>
                                            <img src={this.state.dynamicDataForCurrCategory?.['app_section']?.['banner_image']} className={[styles['title-img']]} alt=""/> 
                                            <h3>{this.state.dynamicDataForCurrCategory?.['app_section']?.['heading']}</h3>
                                            {/* <p>{this.state.dynamicDataForCurrCategory?.['app_section']?.['sub_heading']}</p> */}
                                        </div>
                                        <div className={[styles['mobile-image'],'col-md-5'].join(' ')}>
                                            <img src={this.state.dynamicDataForCurrCategory?.['app_section']?.['side_image']} alt=""/>
                                        </div>
                                        <div className={[styles['title'],'col-md-6 offset-md-1'].join(' ')}> 
                                            <Accordion allowZeroExpanded preExpanded={['a']} id='accordian-to-start-interval'>
                                                {
                                                    this.state.dynamicDataForCurrCategory?.['app_section']?.['content'] ? 
                                                    this.state.dynamicDataForCurrCategory['app_section']['content'].map((contentData,index)=>{
                                                        return  (<AccordionItem uuid={`accordian_${index}`} className={[styles['mobile-app-accordion-item'],'mobile-app-accordion-item'].join(' ')} 
                                                                    // dangerouslySetExpanded={this.state.showAccordianTimeInterval.show && this.state.showAccordianTimeInterval.expandItem[index]}
                                                                    dangerouslySetExpanded={true}
                                                                >
                                                                    <AccordionItemHeading>
                                                                        <AccordionItemButton className={[styles['mobile-app-accordion-button'],'mobile-app-accordion-button'].join(' ')}>
                                                                            <h4><img src={contentData['accordion_item_on_img']} alt="Shoot With Phone" className="orange"/> 
                                                                                <img src={contentData['accordion_item_off_img']} alt="Shoot With Phone" className="grey"/> 
                                                                                {contentData['content_heading']}
                                                                            </h4> 
                                                                        </AccordionItemButton>
                                                                    </AccordionItemHeading>
                                                                    <AccordionItemPanel className={[styles['mobile-app-accordion-content']]}>
                                                                        <h6>{contentData['content_subheading']}</h6>

                                                                        {
                                                                            contentData['content_description'] ? contentData['content_description'].map((desc,i)=>{
                                                                                return (
                                                                                    <p key={`${desc['bullet_img']}_${i}_content_description`}>
                                                                                        <img src={desc['bullet_img']} alt=""/> 
                                                                                        <span>{desc['text']}</span>
                                                                                    </p>
                                                                                )
                                                                            }) : null
                                                                        }
                                                                    </AccordionItemPanel>
                                                                </AccordionItem>)
                                                    }) : null
                                                }
                                            </Accordion>
                                        </div>
                                        
                                    </div>
                                </div>
                            </section>

                            {/* Web */}
                            <section className={[styles['web-app'],''].join(' ')} id="web-app" ref={this.state.activeElementsRef.webSection}> 
                                <div className={[styles[''],'container'].join(' ')}>
                                    <div className={[styles[''],'row'].join(' ')}>
                                        <div className={[styles['title'],'col-md-12 text-center'].join(' ')}>
                                            <img src={this.state.dynamicDataForCurrCategory?.['web_section']?.['banner_image']} className={[styles['title-img']]} alt=""/> 
                                            <h3>{this.state.dynamicDataForCurrCategory?.['web_section']?.['heading']}</h3>
                                            <p>{this.state.dynamicDataForCurrCategory?.['web_section']?.['sub_heading']}</p>
                                            <img src={this.state.dynamicDataForCurrCategory?.['web_section']?.['banner_image2']}  alt="" className={[styles['web-img-sm']]}/>
                                        </div>
                                        <div className={[styles['title'],'col-md-6'].join(' ')}> 
                                            <h2>{this.state.dynamicDataForCurrCategory?.['web_section']?.['banner_heading']}</h2>
                                            <p>{this.state.dynamicDataForCurrCategory?.['web_section']?.['banner_sub_heading']}</p>
                                            <ul>
                                            
                                            {
                                                this.state.dynamicDataForCurrCategory?.['web_section']?.['web_description'] ? 
                                                this.state.dynamicDataForCurrCategory['web_section']['web_description'].map((desc,i)=>{
                                                    return (
                                                        <li key={`${desc['bullet_img']}_${i}_web_description}`}>
                                                            <img src={desc['bullet_img']} alt=""/> 
                                                            <span>{desc['text']}</span>
                                                        </li>
                                                    )
                                                }):null
                                            }                
                                                {/* <li><img src={imageSrc[20].src}/> <span>Make your videos live faster onto your website instantly </span></li>
                                                <li><img src={imageSrc[20].src}/> <span>Let your shoppers explore your vehicles & help them make informed decisions. </span></li> */}
                                            </ul>

                                            <div className="text-center"><a href={this.state.dynamicDataForCurrCategory?.['web_section']?.['start_now_link']} className={[styles['start-btn']]} style={{display: "inline-block",marginTop: "4px",padding: "6px 20px"}} target="_blank">Start Now <i className="fa fa-arrow-right" aria-hidden="true"></i></a></div>
                                        </div>
                                        <div className={[styles['web-images'],'col-md-6'].join(' ')}>
                                            {/* <img src={imageSrc[21].src} alt="" className={[styles['web-img-big']]}/> */}
                                            <img src={this.state.dynamicDataForCurrCategory?.['web_section']?.['banner_image2']} className={[styles['web-img-big']]} alt=""/> 
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* api */}
                            <section className={[styles['api-app'],''].join(' ')} id="api-app" ref={this.state.activeElementsRef.apiSection}> 
                                <div className={[styles[''],'container'].join(' ')}>
                                    <div className={[styles[''],'row'].join(' ')}>
                                        <div className={[styles['title'],'col-md-12 text-center'].join(' ')}>
                                            <img src={this.state.dynamicDataForCurrCategory?.['api_section']?.['banner_image']} className={[styles['title-img']]} alt=""/> 
                                            <h3>{this.state.dynamicDataForCurrCategory?.['api_section']?.['heading']}</h3>
                                        </div>
                                        <div className={[styles['api-code-area'],'col-md-6'].join(' ')}>
                                            <Tabs className={[styles['api-box'],'row api-box'].join(' ')}>
                                                <TabList>
                                                <Tab>Curl</Tab>
                                                <Tab>js</Tab>
                                                <Tab>Python</Tab>
                                                <Tab>Swift</Tab>
                                                </TabList>

                                                <TabPanel>
                                                    <div className={[styles['code-text'],'row'].join(' ')}>
                                                        <p className={[styles['copiedBtn'],''].join(' ')} onClick={this.handleCopy}><span>
                                                        {this.state.copied ? <small className={styles['copy-show']}>Copied! </small>
                                                        : null} <i className="fa fa-clone" aria-hidden="true"></i></span></p>
                                                        <code id="CurlText"><span style={{color: "#fff"}}>curl --location --request</span> <span style={{color: "red"}}> POST </span> 'https://www.clippr.ai/api/v3/image/replacebg' <span style={{color: "#fff"}}>&#92;</span><br/>
                                                            <span style={{color: "#fff"}}>--form</span> 'auth_key="145c0c6b-eb9f-4034-bda8-7bcfeb183c39"' <span style={{color: "#fff"}}>&#92;</span><br/>
                                                            <span style={{color: "#fff"}}>--form</span> 'image_url="https://storage.googleapis.com/spyne/AI/raw/img-69ef06df-ea4f-40e0-bec5-81006bc6fabb.jpg"' <span style={{color: "#fff"}}>&#92;</span><br/>
                                                            <span style={{color: "#fff"}}>--form</span> 'background_id="924"' <span style={{color: "#fff"}}>&#x5c;</span><br/>
                                                            <span style={{color: "#fff"}}>--form</span> 'prod_cat_id="cat_d8R14zUNE"' <span style={{color: "#fff"}}>&#x5c;</span><br/>
                                                            <span style={{color: "#fff"}}>--form</span> 'sku_name="HR26BD6143"'
                                                        </code>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel>
                                                <div className={[styles['code-text'],'row'].join(' ')}>
                                                    <p className={[styles['copiedBtn'],''].join(' ')} onClick={this.handleCopy}><span>
                                                        {this.state.copied ? <small className={styles['copy-show']}>Copied! </small>
                                                        : null} <i className="fa fa-clone" aria-hidden="true"></i></span></p>
                                                    <code id="CurlText"> <span className={[styles['sky'],''].join(' ')}>var</span> <span className={[styles['white'],''].join(' ')}>axios =</span> <span className={[styles['func'],''].join(' ')}>require</span>('axios');<br/>
                                                    <span className={[styles['sky'],''].join(' ')}>var</span>  FormData = <span className={[styles['func'],''].join(' ')}>require</span>('form-data');<br/>
                                                    <span className={[styles['sky'],''].join(' ')}>var</span>  <span className={[styles['white'],''].join(' ')}>data =</span> <span className={[styles['sky'],''].join(' ')}>new</span> FormData();<br/>
                                                    <span className={[styles['white'],''].join(' ')}>data.</span><span className={[styles['func'],''].join(' ')}>append</span>('auth_key', '145c0c6b-eb9f-4034-bda8-7bcfeb183c39');<br/>
                                                    <span className={[styles['white'],''].join(' ')}>data.</span><span className={[styles['func'],''].join(' ')}>append</span>('image_url', 'https://storage.googleapis.com/spyne/AI/raw/img-69ef06df-ea4f-40e0-bec5-81006bc6fabb.jpg');<br/>
                                                    <span className={[styles['white'],''].join(' ')}>data.</span><span className={[styles['func'],''].join(' ')}>append</span>('background_id', '924');<br/>
                                                    <span className={[styles['white'],''].join(' ')}>data.</span><span className={[styles['func'],''].join(' ')}>append</span>('prod_cat_id', 'cat_d8R14zUNE');<br/>
                                                    <span className={[styles['white'],''].join(' ')}>data.</span><span className={[styles['func'],''].join(' ')}>append</span>('sku_name', 'HR26BD6143');<br/><br/>
                                                    
                                                    <span className={[styles['sky'],''].join(' ')}>var</span>  <span className={[styles['white'],''].join(' ')}>config = &#123; </span><br/>
                                                    <span className={[styles['white'],''].join(' ')}>method:</span> 'post'<span className={[styles['white'],''].join(' ')}>,</span><br/>
                                                    <span className={[styles['white'],''].join(' ')}>url:</span> 'https://www.clippr.ai/api/v3/image/replacebg',<br/>
                                                    <span className={[styles['white'],''].join(' ')}>headers: &#123;</span> <br/>
                                                        <span className={[styles['white'],''].join(' ')}>...data.</span><span className={[styles['func'],''].join(' ')}>getHeaders</span><span className={[styles['white'],''].join(' ')}>()<br/>
                                                        &#125;,<br/>
                                                    data : data<br/>
                                                    &#125;;</span><br/><br/>
                                                    
                                                    <span className={[styles['func'],''].join(' ')}>axios</span><span className={[styles['white'],''].join(' ')}>(config)<br/>
                                                    <span className={[styles['func'],''].join(' ')}>.then</span>(<span className={[styles['sky'],''].join(' ')}>function</span> (response) &#123;<br/>
                                                    console.<span className={[styles['func'],''].join(' ')}>log</span>(<span className={[styles['json'],''].join(' ')}>JSON</span><span className={[styles['func'],''].join(' ')}>.stringify</span>(response.data));<br/>
                                                    &#125;)<br/>
                                                    <span className={[styles['func'],''].join(' ')}>.catch</span>(<span className={[styles['sky'],''].join(' ')}>function</span> (error) &#123;<br/>
                                                    console.<span className={[styles['func'],''].join(' ')}>log</span>(error);<br/>
                                                    &#125;);</span>
                                                    </code>
                                                </div>
                                                </TabPanel>
                                                <TabPanel>
                                                <div className={[styles['code-text'],'row'].join(' ')}>
                                                    <p className={[styles['copiedBtn'],''].join(' ')} onClick={this.handleCopy}><span>
                                                        {this.state.copied ? <small className={styles['copy-show']}>Copied! </small>
                                                        : null} <i className="fa fa-clone" aria-hidden="true"></i></span></p>
                                                    <code id="CurlText"> <span className={[styles['sky'],''].join(' ')}>import</span> <span className={[styles['white'],''].join(' ')}>requests<br/>

                                                        url =</span> "https://www.clippr.ai/api/v3/image/replacebg"<br/>

                                                        <span className={[styles['white'],''].join(' ')}>payload=&#123;</span>'auth_key': '145c0c6b-eb9f-4034-bda8-7bcfeb183c39',<br/>
                                                        'image_url': 'https://storage.googleapis.com/spyne/AI/raw/img-69ef06df-ea4f-40e0-bec5-81006bc6fabb.jpg',<br/>
                                                        'background_id': '924',<br/>
                                                        'prod_cat_id': 'cat_d8R14zUNE',<br/>
                                                        'sku_name': 'HR26BD6143'<span className={[styles['white'],''].join(' ')}>&#125; <br/>
                                                        files=[<br/><br/>

                                                        ]<br/>
                                                        headers = &#123;&#125;<br/><br/>

                                                        response = requests.</span><span className={[styles['func'],''].join(' ')}>request</span>("POST"<span className={[styles['white'],''].join(' ')}>, url, headers=headers, data=payload, files=files)<br/><br/>

                                                        <span className={[styles['func'],''].join(' ')}>print</span>(response.text)</span><br/>
                                                        </code>
                                                    </div>
                                                </TabPanel>
                                                <TabPanel>
                                                    <div className={[styles['code-text'],'row'].join(' ')}>
                                                        <p className={[styles['copiedBtn'],''].join(' ')} onClick={this.handleCopy}><span>
                                                        {this.state.copied ? <small className={styles['copy-show']}>Copied! </small>
                                                        : null} <i className="fa fa-clone" aria-hidden="true"></i></span></p>
                                                    <code id="CurlText">import <span className={[styles['white'],''].join(' ')}>Foundation<br/>
                                                        #<span className={[styles['sky'],''].join(' ')}>if</span> <span className={[styles['func'],''].join(' ')}>canImport</span>(FoundationNetworking)<br/>
                                                        <span className={[styles['sky'],''].join(' ')}>import</span> FoundationNetworking<br/>
                                                        #endif<br/><br/>

                                                        <span className={[styles['sky'],''].join(' ')}>var</span> 
                                                        semaphore = <span className={[styles['func'],''].join(' ')}>DispatchSemaphore</span> 
                                                        (value: <span style={{color: "#ae81ff"}}>0</span>)<br/><br/>

                                                        <span className={[styles['sky'],''].join(' ')}>let</span> parameters = &#91;<br/>
                                                            &#91;</span><br/>
                                                            "key": "auth_key",<br/>
                                                            "value": "145c0c6b-eb9f-4034-bda8-7bcfeb183c39",<br/>
                                                            "type": "text"<br/>
                                                        <span className={[styles['white'],''].join(' ')}>],<br/>
                                                        [</span><br/>
                                                            "key": "image_url",<br/>
                                                            "value": "https://storage.googleapis.com/spyne/AI/raw/img-69ef06df-ea4f-40e0-bec5-81006bc6fabb.jpg",<br/>
                                                            "type": "text"<br/>
                                                        <span className={[styles['white'],''].join(' ')}>],<br/>
                                                        [</span><br/>
                                                            "key": "background_id",<br/>
                                                            "value": "924",<br/>
                                                            "type": "text"<br/>
                                                        <span className={[styles['white'],''].join(' ')}>],<br/>
                                                        [</span><br/>
                                                            "key": "prod_cat_id",<br/>
                                                            "value": "cat_d8R14zUNE",<br/>
                                                            "type": "text"<br/>
                                                        <span className={[styles['white'],''].join(' ')}>],<br/>
                                                        [</span><br/>
                                                            "key": "sku_name",<br/>
                                                            "value": "HR26BD6143",<br/>
                                                            "type": "text"<br/>
                                                        <span className={[styles['white'],''].join(' ')}>]] <span className={[styles['sky'],''].join(' ')}>as</span> [[String : Any]]<br/><br/>

                                                        <span className={[styles['sky'],''].join(' ')}>let</span> boundary =</span> "Boundary-\(UUID().uuidString)"<br/>
                                                        <span className={[styles['sky'],''].join(' ')}>var</span>  <span className={[styles['white'],''].join(' ')}>body =</span> ""<br/>
                                                        <span className={[styles['sky'],''].join(' ')}>var</span>  <span className={[styles['white'],''].join(' ')}>error: Error? = nil<br/>
                                                        <span className={[styles['sky'],''].join(' ')}>for</span> param in parameters &#123;<br/>
                                                        <span className={[styles['sky'],''].join(' ')}>if</span> param[</span>"disabled"<span className={[styles['white'],''].join(' ')}>] == nil &#123;<br/>
                                                            <span className={[styles['sky'],''].join(' ')}>let</span> paramName = param[</span>"key"<span className={[styles['white'],''].join(' ')}>]!<br/>
                                                            body +=</span> "--\(boundary)\r\n"<br/>
                                                            body += "Content-Disposition:form-data; name=\"\(paramName)\""<br/>
                                                            if param["contentType"] != nil &#123;<br/>
                                                            body += "\r\nContent-Type: \(param["contentType"] as! String)"<br/>
                                                            &#123;<br/>
                                                            let paramType = param["type"] as! String<br/>
                                                            if paramType == "text" &#123;<br/>
                                                            let paramValue = param["value"] as! String<br/>
                                                            body += "\r\n\r\n\(paramValue)\r\n"<br/>
                                                            &#125; else &#123;<br/>
                                                            let paramSrc = param["src"] as! String<br/>
                                                            let fileData = try NSData(contentsOfFile:paramSrc, options:[]) as Data<br/>
                                                            let fileContent = String(data: fileData, encoding: .utf8)!<br/>
                                                            body += "; filename=\"\(paramSrc)\"\r\n"<br/>
                                                                + "Content-Type: \"content-type header\"\r\n\r\n\(fileContent)\r\n"<br/>
                                                                &#125;<br/>
                                                            &#125;<br/>
                                                        &#125;<br/>
                                                        body += "--\(boundary)--\r\n";<br/>
                                                        let postData = body.data(using: .utf8)<br/><br/>

                                                        <span className={[styles['sky'],''].join(' ')}>var</span>  request = URLRequest(url: <span className={[styles['json'],''].join(' ')}>URL</span>(string: "https://www.clippr.ai/api/v3/image/replacebg")!,timeoutInterval: Double.infinity)<br/>
                                                        request.addValue("multipart/form-data; boundary=\(boundary)", forHTTPHeaderField: "Content-Type")<br/><br/>

                                                        request.httpMethod = "POST"<br/>
                                                        request.httpBody = postData<br/><br/>

                                                        let task = URLSession.shared.dataTask(with: request) &#123; data, response, error in <br/>
                                                        guard let data = data else &#123;<br/>
                                                            print(String(describing: error))<br/>
                                                            semaphore.signal()<br/>
                                                            return<br/>
                                                            &#125;<br/>
                                                        print(String(data: data, encoding: .utf8)!)<br/>
                                                        semaphore.signal()<br/>
                                                        &#125;<br/><br/>

                                                        task.resume()<br/>
                                                        semaphore.wait()<br/>  
                                                        </code>
                                                    </div>
                                                </TabPanel>
                                            </Tabs>
                                        </div>
                                        <div className={[styles['title'],'col-md-5 offset-md-1'].join(' ')}> 
                                            <h2>{this.state.dynamicDataForCurrCategory?.['api_section']?.['banner_heading']}</h2>
                                            <p>{this.state.dynamicDataForCurrCategory?.['api_section']?.['banner_sub_heading']}</p>
                                            
                                            {
                                                this.state.dynamicDataForCurrCategory?.['api_section']?.['api_description'] ? 
                                                <ul>
                                                {
                                                    this.state.dynamicDataForCurrCategory['api_section']['api_description'].map((desc,i)=>{
                                                        return (
                                                            <li key={`${desc['bullet_img']}_${i}_api_description}`}>
                                                                <img src={desc['bullet_img']} alt=""/> 
                                                                <span>{desc['text']}</span>
                                                            </li>
                                                        )
                                                    })
                                                }
                                                </ul> : null
                                            }  
                                            
                                            <div className="text-center"><a href={this.state.dynamicDataForCurrCategory?.['api_section']?.['start_now_link']} className={[styles['start-btn']]} style={{display: "inline-block",marginTop: "4px",padding: "6px 20px"}} target="_blank">Start Now <i className="fa fa-arrow-right" aria-hidden="true"></i></a></div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </section>
                            {/* Dashboard Section  */}
                            <section className={[styles['dashboard-app'],''].join(' ')} id="dashboard-app" ref={this.state.activeElementsRef.dashboardSection}> 
                                <div className={[styles[''],'container'].join(' ')}>
                                    <div className={[styles[''],'row'].join(' ')}>
                                        <div className={[styles['title'],'col-md-12 text-center'].join(' ')}>
                                            <img src={this.state.dynamicDataForCurrCategory?.['dashboard_section']?.['banner_image']} className={[styles['title-img']]} alt=""/> 
                                            <h3>{this.state.dynamicDataForCurrCategory?.['dashboard_section']?.['heading']}</h3>
                                            <p>Create scroll-stopping images for Facebook, Instagram, Youtube and more. Ads, logos? Them too.</p>
                                        </div>
                                        <div className={[styles['dashboard-scroll-area'],'col-md-12 text-center'].join(' ')}>
                                            <HomeDashBoard className={[styles['dashboard-web-view'],''].join(' ')} zoomInImages={this.state.dynamicDataForCurrCategory?.['dashboard_section']?.['zoomInImages']}/>
                                            {/* <img src={imageSrc[38].src} className={[styles['dashboard-small-view'],''].join(' ')}/> */}
                                            <img src={this.state.dynamicDataForCurrCategory?.['dashboard_section']?.['small_image']} className={[styles['dashboard-small-view']]} alt=""/> 
                                        </div>
                                    </div>
                                </div> 
                            </section>
                            {/* Sticky Bar  */}
                            <div className={[styles['sticky-bar']]} style={{width: "380px"}}>
                                <ul id="all-section-container">
                                    <li onClick={e=>this.scrollToRef(e,'mobileSection',0)}>App</li>
                                    <li onClick={e=>this.scrollToRef(e,'webSection',1)}>Web</li>
                                    <li onClick={e=>this.scrollToRef(e,'apiSection',2)}>API</li>
                                    <li onClick={e=>this.scrollToRef(e,'dashboardSection',3)}>Dashboard</li>
                                </ul>
                            </div>
                        </div>
                        {/* Customise your Templates */}
                        <section className={[styles['template-section'],''].join(' ')}>
                            <img src={imageSrc[37].src} className={[styles['temp-bg']]} />
                            <img src={imageSrc[36].src} className={[styles['temp-bg-right']]} />
                            <div className={[styles[''],'container'].join(' ')}>
                                <div className={[styles[''],'row'].join(' ')}>
                                    <div className={[styles['title'],'col-md-12 text-center'].join(' ')}>
                                        <h2>{this.state.dynamicDataForCurrCategory?.['templates']?.['heading']}</h2>
                                        <p>{this.state.dynamicDataForCurrCategory?.['templates']?.['sub_heading']}</p>
                                    </div>
                                    <div className={[styles['template-gallery'],'col-md-12'].join(' ')}>
                                        <ResponsiveMasonry className={[styles['template-gallery-area'],'row'].join(' ')}
                                            columnsCountBreakPoints={{350: 4, 750: 4, 900: 4, 1024: 6, 1180: 6}}>
                                            <Masonry className={[styles['template-gallery-main'],'col-md-12'].join(' ')}>
                                                {
                                                    this.state.dynamicDataForCurrCategory?.['templates']?.['custom_images'] ?
                                                    this.state.dynamicDataForCurrCategory['templates']['custom_images'].map((imageData,index)=>{
                                                        return (
                                                            <div className={[styles['gallery-images'],''].join(' ')} key={`custom_templates_${index}`}>
                                                                <div className={[styles['flip-box'],''].join(' ')}>
                                                                    <div className={[styles['flip-box-inner'],''].join(' ')}>
                                                                        <div className={[styles['flip-box-front'],''].join(' ')}>
                                                                            <img src={imageData['before']} className={[styles['before-image']]} alt=""/>
                                                                        </div>
                                                                        <div className={[styles['flip-box-back'],''].join(' ')}>
                                                                            <img src={imageData['after']} className={[styles['after-image'],''].join('')} alt=""/>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                    : null
                                                }
                                            </Masonry>
                                        </ResponsiveMasonry>
                                        <div className={[styles['template-btn'],'col-md-12 text-center'].join(' ')}>
                                            <a href={this.state.dynamicDataForCurrCategory?.['templates']?.['start_now_link']} className={[styles['browse-btn']]} target="_blank">Browse more templates</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

 
                        {/* Real Stories from Real Customers Slider */}
                        <section className={[styles['real-stories-slider'],'real-stories-slider'].join(' ')}>
                            <img src={imageSrc[19].src} className={[styles['star-bg']]} />
                            <div className={[styles[''],'container'].join(' ')}>
                                <div className={[styles[''],'row'].join(' ')}>
                                    <div className={[styles['title'],'col-md-12 text-center'].join(' ')}>
                                        <h2>Don't Just Take Our Word For it</h2>
                                        <p>Look at what some of our many satisfied customers are saying:</p>
                                    </div>
                                    <div className={[styles[''],'col-md-12 text-center'].join(' ')}>
                                        <Slider {...settings2} className={[styles['slider-area'],'col-md-12 text-center slider-area d-md-block d-none'].join(' ')} > 
                                        {
                                            this.state.dynamicDataForCurrCategory?.['clients_slider'] ?
                                            this.state.dynamicDataForCurrCategory['clients_slider'].map((imageData,index)=>{
                                                return (
                                                <div className={[styles['stories-slider-row'],''].join(' ')} key={`client_slider_${index}`}>
                                               
                                                        <div className={[styles['stories-slide']]}>
                                                         <img src={imageData['company_logo']} />
                                                            <em><img src={imageSrc[23].src}/> {imageData['description']}</em >
                                                           
                                                        </div>
                                                        </div>
                                                            )
                                                        })
                                                        : null
                                                    }
                                                
                                           
                                            </Slider> 
                                            <Slider {...settings3} className={[styles['slider-area'],styles['slider-area2'],'col-md-12 text-center slider-area'].join(' ')} > 
                                               
                                                {
                                                this.state.dynamicDataForCurrCategory?.['clients_slider'] ?
                                                this.state.dynamicDataForCurrCategory['clients_slider'].map((imageData,index)=>{
                                                    return (
                                                    <div className={[styles['stories-slider-row'],''].join(' ')} key={`client_slider_${index}`}>
                                                
                                                            <div className={[styles['stories-slide']]}>
                                                            <img src={imageData['company_logo']} />
                                                                <em><img src={imageSrc[23].src}/> {imageData['description']}</em >
                                                            
                                                            </div>
                                                        </div>
                                                            )
                                                        })
                                                        : null
                                                    }
                                                
                                            
                                           
                                            </Slider> 
                                    </div>
                                </div>
                            </div>
                        </section>
                        {/* Real Stories from Real Customers */}
                        <section className={[styles['case-studies'],''].join(' ')}>
                            <img src={imageSrc[19].src} className={[styles['star-bg']]} />
                            <div className={[styles[''],'container'].join(' ')}>
                                <div className={[styles[''],'row'].join(' ')}>
                                    <div className={[styles['title'],'col-md-12 text-center'].join(' ')}>
                                        <h2>Case Studies</h2>
                                        <p>See why 1000s of businesses use Spyne to accelerate their conversions.</p>
                                    </div>
                                    
                                    <div className={[styles['case-col'],'col-md-4 d-md-block d-none'].join(' ')}>
                                        <div className={[styles['case-single']]}>
                                            <img src="https://storage.googleapis.com/spyne-website/SpyneHome-v2/case-car.jfif"/>
                                            <h4>How Spyne Helps Top Car Dealership Launch Business in Australia with HD Car Images</h4>
                                            <p>Car dealerships use SpyneAI to turn poor car images into premium images-100% automatically...</p>
                                        <h6><span>May 20th 2020</span> <a href="https://www.spyne.ai/blogs/how-spyne-help-leading-car-dealership-launch-business-with-studio-setting-car-images" target="_blank">Read more</a></h6>
                                        </div>
                                    </div>
                                    <div className={[styles['case-col'],'col-md-4 d-md-block d-none'].join(' ')}>
                                        <div className={[styles['case-single']]}>
                                            <img src="https://storage.googleapis.com/spyne-website/SpyneHome-v2/case-fashion.png"/>
                                            <h4>Case Study: How Spyne helps Bigbasket with premium food images across major Indian cities</h4>
                                            <p>Bigbasket collaborates with Spyne to scale its visual content requirements in major cities...</p>
                                        <h6><span>May 20th 2020</span> <a href="https://www.spyne.ai/blogs/spyne-helps-bigbasket-get-premium-product-shoot" target="_blank">Read more</a></h6>
                                        </div>
                                    </div>
                                    <div className={[styles['case-col'],'col-md-4 d-md-block d-none'].join(' ')}>
                                        <div className={[styles['case-single']]}>
                                            <img src="https://storage.googleapis.com/spyne-website/SpyneHome-v2/case-food.jpg"/>
                                            <h4>Create marketplace-ready images for your brand with Spyne's AI tech 100% automatically</h4>
                                            <p>Spyne helps major e-commerce & fashion brands create high-quality, marketplace-ready images...</p>
                                        <h6><span>May 20th 2020</span> <a href="https://www.spyne.ai/blogs/edit-your-e-commerce-catalog-images-3x-faster-with-ai" target="_blank">Read more</a></h6>
                                        </div>
                                    </div>
                                    <Slider {...settings3} className={[styles['slider-area'],styles['slider-area2'],'col-md-12 text-center slider-area d-md-none d-block'].join(' ')} > 
                                            <div className={[styles['case-col'],'col-md-12'].join(' ')}>
                                                <div className={[styles['case-single']]}>
                                                    <img src="https://storage.googleapis.com/spyne-website/SpyneHome-v2/case-food.jpg"/>
                                                    <h4>Create marketplace-ready images for your brand with Spyne's AI tech 100% automatically</h4>
                                                    <p>Spyne helps major e-commerce & fashion brands create high-quality, marketplace-ready images...</p>
                                                    <h6><span>May 20th 2020</span> <a href="https://www.spyne.ai/blogs/edit-your-e-commerce-catalog-images-3x-faster-with-ai" target="_blank">Read more</a></h6>
                                                </div>
                                            </div>
                                            <div className={[styles['case-col'],'col-md-12'].join(' ')}>
                                                <div className={[styles['case-single']]}>
                                                    <img src="https://storage.googleapis.com/spyne-website/SpyneHome-v2/case-fashion.png"/>
                                                    <h4>Case Study: How Spyne helps Bigbasket with premium food images across major Indian cities</h4>
                                                    <p>Bigbasket collaborates with Spyne to scale its visual content requirements in major cities...</p>
                                                <h6><span>May 20th 2020</span> <a href="https://www.spyne.ai/blogs/spyne-helps-bigbasket-get-premium-product-shoot" target="_blank">Read more</a></h6>
                                                </div>
                                            </div>
                                            <div className={[styles['case-col'],'col-md-12'].join(' ')}>
                                                <div className={[styles['case-single']]}>
                                                    <img src="https://storage.googleapis.com/spyne-website/SpyneHome-v2/case-food.jpg"/>
                                                    <h4>Create marketplace-ready images for your brand with Spyne's AI tech 100% automatically</h4>
                                                    <p>Spyne helps major e-commerce & fashion brands create high-quality, marketplace-ready images...</p>
                                                <h6><span>May 20th 2020</span> <a href="https://www.spyne.ai/blogs/edit-your-e-commerce-catalog-images-3x-faster-with-ai" target="_blank">Read more</a></h6>
                                                </div>
                                            </div> 
                                                
                                            </Slider> 
                                    <div className={[styles['case-btn'],'col-md-12 text-center'].join(' ')}>
                                        <a href="https://www.spyne.ai/blogs" className={[styles['start-btn']]} target="_blank">All Resources <i className="fa fa-arrow-right" aria-hidden="true"></i></a>
                                    </div>
                                </div>
                            </div>
                        </section>


                        {/* Media logos Section  */}
                        <section className={[styles['trusted-enterprise'],styles['media-logos'],''].join(' ')}>
                            <div className={[styles[''],'container'].join(' ')}>
                                <div className={[styles[''],'row'].join(' ')}>
                                    <div className={[styles[''],'col-md-12'].join(' ')}>
                                        <h3>{this.state.dynamicDataForCurrCategory?.['media_logos_section']?.['heading']}</h3>
                                        <Slider {...settings4} className={[styles['trusted-clients'],'row trusted-clients'].join(' ')} >
                                                {
                                                    this.state.dynamicDataForCurrCategory?.['media_logos_section']?.['enterprises_list'] ?
                                                    this.state.dynamicDataForCurrCategory['media_logos_section']['enterprises_list'].map((imageData,index)=>
                                                    {
                                                        return (
                                                            <div className={[styles['clients-images'],''].join(' ')} key={`${imageData}_${index}`}>
                                                                <img src={imageData} alt=""/>
                                                            </div> 
                                                        )
                                                    })
                                                    : null
                                                }
                                            </Slider> 
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Footer Section  */}
                        <Footer/>

                    </div>   
                    )
                }
                
                </Dropzone>

                

           
            
         );
    }
}
  


const mapStateToProps = (state, ownProps)=>{
    //console.log({'state.homePageReducer':state.homePageReducer})
    return{
        imageURL : state.homePageReducer.imageURL,
        file : state.homePageReducer.file,
    }
}

const mapDispatchToProps = (dispatch)=>{
    return {
        updateImageFileData : (file)=>dispatch(updateImageFileData(file)),
        updateImageURL : (imageURL,subCategoryId, index,sampleImagesForCurrCategory,pageName)=>dispatch(updateImageURL(imageURL,subCategoryId, index,sampleImagesForCurrCategory,pageName))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);